<template>
    <div>
        <div class="title-bar">
            <div class="volver-atras">
                <DxButton v-bind="backButtonProps()" @click="$router.back()"></DxButton>
                <h1>{{ $t('suceso_detalle.title') }}</h1>
            </div>
        </div>

        <FichaSuceso :sucesoProp="suceso"></FichaSuceso>
        <PestanasSuceso :ficherosMedidaProp="ficherosMedidaDetalleModel"></PestanasSuceso>
    </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { DxButton, } from 'devextreme-vue';
import { onMounted, ref, watch } from 'vue';
import { useApi } from '@/.shared/.api/integration';
import { backButtonProps } from '@helpers/button-helper';
import FichaSuceso from '@/components/sucesos/FichaSuceso.vue';
import PestanasSuceso from '@/components/sucesos/PestanasSuceso.vue';
import type { FicheroMedidaDetalleModel, SucesoDetalleModel } from '@/.shared/.api';

const api = useApi();
const route = useRoute();
const idSuceso = ref<number>();

let suceso = ref<SucesoDetalleModel>({} as SucesoDetalleModel);
let ficherosMedidaDetalleModel = ref<FicheroMedidaDetalleModel[]>([]);

onMounted(() => {
    watch(
        () => route.params.id,
        async (newId: string | string[]) => {
            idSuceso.value = parseInt(newId as string);
            suceso.value = await api.callStandardApi('sucesoGetDetalle', {}, idSuceso.value); // Llamada simple;
            ficherosMedidaDetalleModel.value = await api.callStandardApi('ficheroMedidaGetBySuceso', {}, idSuceso.value);
        },
        { immediate: true }
    );
});
</script>

<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";
</style>